var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","ma-0":"","pa-0":"","fill-height":""}},[_c('div',{attrs:{"id":"map"}})])}
var staticRenderFns = []

export { render, staticRenderFns }